import React from 'react';
import { Link } from 'react-router-dom';
import styles from './HomePage.module.scss';
import CommonHeader from './CommonHeader';

const HomePage: React.FC = () => {
  return (
    <div className={styles.homeContainer}>
      <CommonHeader />

      <main className={styles.homeMain}>
        <div className={styles.homeContent}>
          <h1 className={styles.homeTitle}>Welcome to Synergetics Seller Portal</h1>
          <p className={styles.homeDescription}>
            Start your journey as a seller with our comprehensive platform
          </p>
          
          <div className={styles.homeActions}>
            <Link to="/signup" className={styles.signupLinkBtn}>
              Get Started - Sign Up
            </Link>
            <Link to="/add-business" className={styles.signupLinkBtn} style={{background: '#52c41a', marginTop: '8px'}}>
              Add Your Business
            </Link>
            <Link to="/login" className={styles.loginLinkBtn}>
              Already have an account? Login
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HomePage;